import { HttpParams } from '@angular/common/http';

import { ALL_DEMANDS_DEFAULT_ORDER } from '../Consts/list-all-demands.const';
import {
  AllDemandsFilterCriteria,
  AllDemandsFilters,
} from '../Interfaces/all-demands-filters.interface';
import { DemandExportPayload } from '../Interfaces/demand-export.interface';
import { ReportSubjectTab } from '../Types/report-subject-tab.type';

function presentText(value: string | null): string | undefined {
  const trimmed = value?.trim();
  return trimmed ? trimmed : undefined;
}

export function buildAllDemandsHttpParams(filters: AllDemandsFilters): HttpParams {
  let params = new HttpParams();
  for (const status of filters.statuses) {
    params = params.append('status[]', status);
  }

  const optional: ReadonlyArray<[string, string | undefined]> = [
    ['search', presentText(filters.search)],
    ['requestedFrom', presentText(filters.requestedFrom)],
    ['requestedTo', presentText(filters.requestedTo)],
    ['updatedFrom', presentText(filters.updatedFrom)],
    ['updatedTo', presentText(filters.updatedTo)],
    ['platform', presentText(filters.platform)],
    ['device', presentText(filters.device)],
    ['requesterId', presentText(filters.requesterId)],
    ['subjectId', presentText(filters.subjectId)],
    ['approverId', presentText(filters.approverId)],
    ['moderatorId', presentText(filters.moderatorId)],
    ['decidedById', presentText(filters.decidedById)],
  ];
  for (const [key, value] of optional) {
    if (value !== undefined) params = params.set(key, value);
  }

  return params
    .set('page', filters.page.toString())
    .set('pageSize', filters.pageSize.toString())
    .set('orderBy', filters.orderBy)
    .set('order', filters.order || ALL_DEMANDS_DEFAULT_ORDER);
}

export function buildDemandExportBody(
  scope: ReportSubjectTab,
  criteria: AllDemandsFilterCriteria,
): DemandExportPayload {
  return {
    scope,
    status: criteria.statuses.length > 0 ? [...criteria.statuses] : undefined,
    search: presentText(criteria.search),
    requestedFrom: presentText(criteria.requestedFrom),
    requestedTo: presentText(criteria.requestedTo),
    updatedFrom: presentText(criteria.updatedFrom),
    updatedTo: presentText(criteria.updatedTo),
    platform: presentText(criteria.platform),
    device: presentText(criteria.device),
    requesterId: presentText(criteria.requesterId),
    subjectId: presentText(criteria.subjectId),
    approverId: presentText(criteria.approverId),
    moderatorId: presentText(criteria.moderatorId),
    decidedById: presentText(criteria.decidedById),
  };
}
